import React from 'react';

const columns = {};

export default columns;